import { useEffect, useId, useRef } from 'react';

import { FOCO_VISIVEL } from 'utils/foco';

import ModalDoCatalogo from './ModalDoCatalogo';

interface ModalDeCancelamentoProps {
  isOpen: boolean;
  nome: string;
  prazo: string;
  cancelando: boolean;
  erro?: string;
  onConfirmar: () => void;
  onFechar: () => void;
}

const BOTAO = `flex flex-[1_1_160px] cursor-pointer items-center justify-center rounded-md border-0 px-5 py-[13px] font-text text-[13px] font-bold leading-[normal] uppercase tracking-[0.04em] transition-colors disabled:cursor-not-allowed ${FOCO_VISIVEL}`;

/** "Deseja cancelar esta experiência?" (CAT-33, DESF-01.2): nomeia a escolha e diz até quando dá para escolher outra. */
export default function ModalDeCancelamento({ isOpen, nome, prazo, cancelando, erro, onConfirmar, onFechar }: ModalDeCancelamentoProps) {
  const tituloId = useId();
  const descricaoId = useId();
  const erroRef = useRef<HTMLParagraphElement>(null);

  // Enquanto cancela, o botão desabilitado perde o foco; com o erro, o foco vai para a mensagem.
  useEffect(() => {
    if (erro) erroRef.current?.focus();
  }, [erro]);

  return (
    <ModalDoCatalogo isOpen={isOpen} role="alertdialog" tituloId={tituloId} descricaoId={descricaoId} onFechar={cancelando ? undefined : onFechar}>
      <h2 id={tituloId} className="m-0 mb-3 pr-8 font-display text-[24px] font-extrabold leading-[1.2] text-brand-blue-dark">
        Deseja cancelar esta experiência?
      </h2>
      <p id={descricaoId} className="m-0 mb-5 text-[15px] leading-[1.6]">
        <strong className="text-brand-blue-dark">{nome}</strong>
        <br />
        Você poderá escolher outra experiência até <strong>{prazo}</strong>.
      </p>
      {erro && (
        <p ref={erroRef} tabIndex={-1} role="alert" className={`m-0 mb-5 rounded-lg bg-surface-100 px-4 py-3 text-[13px] font-bold leading-[1.5] text-[#B3123A] ${FOCO_VISIVEL}`}>
          {erro}
        </p>
      )}
      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={onFechar} disabled={cancelando} className={`${BOTAO} bg-surface-200 text-brand-blue-dark hover:bg-surface-300`}>
          Não, voltar
        </button>
        <button
          type="button"
          onClick={onConfirmar}
          disabled={cancelando}
          className={`${BOTAO} bg-brand-yellow text-brand-blue-dark hover:bg-button-primary-hover`}
        >
          {cancelando ? 'Cancelando...' : 'Sim, cancelar'}
        </button>
      </div>
    </ModalDoCatalogo>
  );
}
